import { render, staticRenderFns } from "./SidePanelFooter.vue?vue&type=template&id=73ee4b7f&"
import script from "./SidePanelFooter.vue?vue&type=script&lang=ts&"
export * from "./SidePanelFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SidePanelFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports